export default __webpack_public_path__ + "static/ictc-3909934b2f1a2e5fa46ef8f68600d4e0.png";